const ACTIVE_WORKOUT_DRAFTS_KEY = 'activeWorkoutDrafts';

const safeParse = (value, fallback) => {
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export const getStoredWorkoutUserId = () => {
  if (typeof window === 'undefined') return null;
  const user = safeParse(window.localStorage.getItem('user') || 'null', null);
  return user?.sub || user?._id || user?.id || null;
};

const readDrafts = () => {
  if (typeof window === 'undefined') return [];
  const raw = window.localStorage.getItem(ACTIVE_WORKOUT_DRAFTS_KEY);
  const parsed = safeParse(raw || '[]', []);
  return Array.isArray(parsed) ? parsed : [];
};

const writeDrafts = (drafts) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(ACTIVE_WORKOUT_DRAFTS_KEY, JSON.stringify(drafts));
};

export const getActiveWorkoutDraftKey = ({ userId, workoutId, scheduleId }) => {
  return [userId || 'anonymous', workoutId || 'unknown-workout', scheduleId || 'no-schedule'].join('::');
};

export const getActiveWorkoutDraft = ({ userId, workoutId, scheduleId }) => {
  const draftKey = getActiveWorkoutDraftKey({ userId, workoutId, scheduleId });
  return readDrafts().find(draft => draft.draftKey === draftKey) || null;
};

export const upsertActiveWorkoutDraft = (draft) => {
  if (!draft?.draftKey) return;
  const drafts = readDrafts().filter(existing => existing.draftKey !== draft.draftKey);
  drafts.unshift(draft);
  drafts.sort((a, b) => new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0));
  writeDrafts(drafts.slice(0, 20));
};

export const removeActiveWorkoutDraft = ({ userId, workoutId, scheduleId, draftKey }) => {
  const resolvedKey = draftKey || getActiveWorkoutDraftKey({ userId, workoutId, scheduleId });
  writeDrafts(readDrafts().filter(draft => draft.draftKey !== resolvedKey));
};

export const listActiveWorkoutDrafts = (userId) => {
  return readDrafts()
    .filter(draft => !userId || draft.userId === userId)
    .sort((a, b) => new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0));
};